// src/index.js - VERSIÓN DEFINITIVA + GOOGLE
import React from 'react';
import ReactDOM from 'react-dom/client';

// ⭐⭐ IMPORTANTE: setup PRIMERO
import './setup';

// ⭐⭐ AppKit
import { createAppKit } from '@reown/appkit/react';
import { mainnet, polygon, arbitrum, bsc } from '@reown/appkit/networks';

// ⭐⭐ Google OAuth
import { GoogleOAuthProvider } from '@react-oauth/google';

// ⭐⭐ Project ID AppKit
const projectId =
  window.REACT_APP_APPKIT_PROJECT_ID ||
  "df139799df85ef65e80aa73d82a14195";

console.log(
  '🚀 Inicializando AppKit con Project ID:',
  projectId.substring(0, 10) + '...'
);

try {
  createAppKit({
    projectId,
    metadata: {
      name: 'Reanimeitor Wallet',
      description: 'Tu dApp de tokens BGP',
      url: window.location.origin,
      icons: ['https://avatars.githubusercontent.com/u/179229932']
    },
    networks: [mainnet, polygon, arbitrum, bsc],
    features: {
      analytics: false
    }
  });

  console.log('✅ AppKit inicializado CORRECTAMENTE');
} catch (error) {
  console.error('❌ Error inicializando AppKit:', error);
}

// ⭐⭐ App DESPUÉS de AppKit
import App from './App';

// ⭐⭐ Google Client ID
const GOOGLE_CLIENT_ID =
  "198919479956-5ite00gkhmuufp7nmik46aipr54ukomn.apps.googleusercontent.com";

console.log('⚡ Reanimeitor - Renderizando aplicación...');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);
